import { AtImage } from '../../atoms'
import { MlCtaBar, MlCtaBarProps } from '../ml-cta-bar'
import { Image } from '../ml-images'

export interface MlCustomCardProps {
  image: Image
  title: string
  description?: string
  className?: string
  ctaBar?: MlCtaBarProps
}

export const MlCustomCard = ({ image, title, description, className, ctaBar }: MlCustomCardProps) => {
  const ctaBarSizeClasses = ctaBar?.secondaryLabel ? 'h-[6.688rem] slg:h-[7.25rem]' : 'h-14'
  const imageSizeClasses = 'mb-6 aspect-[4/3] lg:aspect-[16/9]'

  return (
    <div
      className={`h-fit relative rounded-4 border-1 border-transparent hover:border-neutrals-400 active:border-neutrals-600 [&:has(a:focus-visible)]:border-neutrals-900 [&:has(a:focus-visible)]:rounded-0 ${className}`}
    >
      <div className="h-full p-2 lg:p-4 flex flex-col focus:outline-none relative z-[2]">
        {/* Space for the images */}
        <div className={`${imageSizeClasses} relative overflow-hidden`}>
          <AtImage alt={image.alt} src={image.src} width={image.width} height={image.height} variant="cover" />
        </div>

        <p className="font-heading font-medium text-24 leading-1.3 text-neutrals-900 line-clamp-1">{title}</p>
        <div className="flex flex-col gap-4 mt-4 justify-between">
          {description && <p className="text-neutrals-800 text-16"> {description}</p>}

          {/* White space for uneven cards */}
          <div className="flex-1" />

          {/* Space for the CTA bar */}
          {ctaBar && <div className={ctaBarSizeClasses} />}
        </div>
      </div>

      {ctaBar && (
        <MlCtaBar
          {...ctaBar}
          parentName="MlBuildingCard"
          className={`z-10 absolute bottom-4 lg:bottom-4 left-2 lg:left-0 right-2 lg:right-0 ${ctaBarSizeClasses} !gap-3 `}
          secondaryClassName="lg:max-w-[21.667rem] px-[0.25rem]"
          primaryClassName="lg:max-w-[21.667rem] px-[0.25rem]"
        />
      )}
    </div>
  )
}
